/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { accesibilidadControllerActualizarAccesibilidad } from '../fn/accesibilidad/accesibilidad-controller-actualizar-accesibilidad';
import { AccesibilidadControllerActualizarAccesibilidad$Params } from '../fn/accesibilidad/accesibilidad-controller-actualizar-accesibilidad';
import { accesibilidadControllerObtenerAccesibilidad } from '../fn/accesibilidad/accesibilidad-controller-obtener-accesibilidad';
import { AccesibilidadControllerObtenerAccesibilidad$Params } from '../fn/accesibilidad/accesibilidad-controller-obtener-accesibilidad';
import { AccesibilidadDto } from '../models/accesibilidad-dto';

@Injectable({ providedIn: 'root' })
export class AccesibilidadService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accesibilidadControllerObtenerAccesibilidad()` */
  static readonly AccesibilidadControllerObtenerAccesibilidadPath = '/api/accesibilidad/obtener-accesibilidad';

  /**
   * Obtener accesibilidad del usuario.
   *
   * Obtiene la configuración de accesibilidad del usuario autenticado. Requiere que el usuario esté autenticado y tenga un UUID válido.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accesibilidadControllerObtenerAccesibilidad()` instead.
   *
   * This method doesn't expect any request body.
   */
  accesibilidadControllerObtenerAccesibilidad$Response(params?: AccesibilidadControllerObtenerAccesibilidad$Params, context?: HttpContext): Observable<StrictHttpResponse<AccesibilidadDto>> {
    return accesibilidadControllerObtenerAccesibilidad(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener accesibilidad del usuario.
   *
   * Obtiene la configuración de accesibilidad del usuario autenticado. Requiere que el usuario esté autenticado y tenga un UUID válido.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accesibilidadControllerObtenerAccesibilidad$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accesibilidadControllerObtenerAccesibilidad(params?: AccesibilidadControllerObtenerAccesibilidad$Params, context?: HttpContext): Observable<AccesibilidadDto> {
    return this.accesibilidadControllerObtenerAccesibilidad$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccesibilidadDto>): AccesibilidadDto => r.body)
    );
  }

  /** Path part for operation `accesibilidadControllerActualizarAccesibilidad()` */
  static readonly AccesibilidadControllerActualizarAccesibilidadPath = '/api/accesibilidad/actualizar-accesibilidad';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accesibilidadControllerActualizarAccesibilidad()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accesibilidadControllerActualizarAccesibilidad$Response(params: AccesibilidadControllerActualizarAccesibilidad$Params, context?: HttpContext): Observable<StrictHttpResponse<AccesibilidadDto>> {
    return accesibilidadControllerActualizarAccesibilidad(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accesibilidadControllerActualizarAccesibilidad$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accesibilidadControllerActualizarAccesibilidad(params: AccesibilidadControllerActualizarAccesibilidad$Params, context?: HttpContext): Observable<AccesibilidadDto> {
    return this.accesibilidadControllerActualizarAccesibilidad$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccesibilidadDto>): AccesibilidadDto => r.body)
    );
  }

}
